import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import {
  useRegisterTraining,
  useStudentRegistration,
  useTrainingList,
  useCancelRegistration,
} from "../../api/trainingApi";
import type { TrainingType } from "../../types/training";
import {
  StudentRegisteredTrainingTableDef,
  StudentTrainingTableDef,
} from "../../table/TrainingTableDef";

const RegisterTraining = () => {
  const { data: trainingListData } = useTrainingList();
  const { data: trainingRegistration } = useStudentRegistration();

  const trainingList: TrainingType[] = trainingListData || [];
  const { mutateAsync: registerTraining } = useRegisterTraining();
  const { mutateAsync: cancelRegistration } = useCancelRegistration();

  const trainingTable = useMaterialReactTable({
    data: trainingList,
    columns: StudentTrainingTableDef(registerTraining),
    defaultColumn: { minSize: 0, maxSize: 200, size: 0 },
    enableFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableHiding: false,
    enableDensityToggle: false,
    enableColumnActions: false,
    enableFullScreenToggle: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    state: {
      density: "compact",
    },
    initialState: {
      columnVisibility: {
        instructor_email: false,
      },
    },
    muiTableBodyCellProps: { align: "center" },
    muiTableHeadCellProps: { align: "center" },
    muiTableFooterProps: {},
  });

  const registrationTable = useMaterialReactTable({
    data: trainingRegistration?.registration
      ? [trainingRegistration.registration]
      : [],
    columns: StudentRegisteredTrainingTableDef(cancelRegistration),
    defaultColumn: { minSize: 0, maxSize: 200, size: 0 },
    enableFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableHiding: false,
    enableDensityToggle: false,
    enableColumnActions: false,
    enableFullScreenToggle: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    state: {
      density: "compact",
    },
    initialState: {
      columnVisibility: {
        instructor_email: false,
      },
    },
    muiTableBodyCellProps: { align: "center" },
    muiTableHeadCellProps: { align: "center" },
    muiTableFooterProps: {},
  });

  return (
    <div>
      <h3>신청한 실습</h3>
      {trainingRegistration?.registration ? (
        <MaterialReactTable table={registrationTable} />
      ) : (
        <p>신청한 실습이 없습니다.</p>
      )}
      <h3>실습 목록</h3>
      <MaterialReactTable table={trainingTable} />
    </div>
  );
};

export default RegisterTraining;
